var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMegaphone = function SvgMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B58E3",
    stroke: "#1F1C22",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M163.98 160.574c19.044-7.405 22.933-43.109 8.686-79.747s-41.233-60.337-60.277-52.932c-19.043 7.405-22.932 43.11-8.686 79.748 14.247 36.638 41.234 60.336 60.277 52.931"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B58E3",
    d: "m154.273 161.798-112.198-6.033c-12.87 0-23.325-10.455-23.325-23.324 0-6.434 3.217-12.869 7.239-17.292l80.026-83.244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1C22",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m154.273 161.798-112.198-6.033c-12.87 0-23.325-10.455-23.325-23.324 0-6.434 3.217-12.869 7.239-17.292l80.026-83.244"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1C22",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M81.083 157.776c-8.043-.804-18.901-13.271-25.737-30.965-6.837-17.292-7.24-33.378-2.413-39.813"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F1C22",
    stroke: "#1F1C22",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m162.718 86.998-39.812 34.585c11.662 20.51 26.541 32.574 36.997 28.552 12.869-5.227 14.075-33.378 2.815-63.137M155.882 71.315 115.667 106.3c-.402-.804-.804-2.011-1.206-3.217-12.064-30.965-10.858-59.92 2.011-65.147 11.26-4.022 27.345 10.456 39.41 33.378"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B58E3",
    d: "M83.093 158.58c0 8.445-6.836 14.879-15.683 14.879s-15.684-6.434-15.684-14.477v-2.011"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1C22",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M83.093 158.58c0 8.445-6.836 14.879-15.683 14.879s-15.684-6.434-15.684-14.477v-2.011"
  })));
};
export default SvgMegaphone;